const TIMEZONE_SUFFIX = /(?:Z|[+-]\d{2}:\d{2})$/;

export const parseUtcTimestamp = (timestamp: string): number => {
  const millisecondPrecision = timestamp.replace(/(\.\d{3})\d+/, '$1');
  const normalizedTimestamp = TIMEZONE_SUFFIX.test(millisecondPrecision)
    ? millisecondPrecision
    : `${millisecondPrecision}Z`;

  return Date.parse(normalizedTimestamp);
};
